/**
 * Init locale
 */
window.Lang.setLocale(window.locale);


// WEBPACK FOOTER //
// ./public/vendor/js-localization/initLang.js